import { BlockTitle } from "@blocks/Blocks";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Options,
  Splide,
  SplideSlide,
  SplideTrack,
} from "@greglaisph/react-splide";
import { useWindowSize } from "@hooks/useWindowSize";
import { getSliderCardSize } from "@pages/Keyword/templates/CampaignTemplate/utils/helper";
import { FeedVideosType } from "@pages/Keyword/utils/types";

import VideoCard from "./VideoCard";

import "@greglaisph/react-splide/css";

type VideoProps = {
  /** data for videos section */
  videoData: FeedVideosType;
  /** classname for videos section */
  className: string;
};

/**
 * Video cards with title that is displayed in videos section
 * https://www.figma.com/design/QCEPjsj7Sdm5KqnY3ta5tq/TEMPLATES--WEB---APP-?node-id=1-12561&t=WWWD4wL9JTRjKHBD-4
 */
const Videos = ({ className, videoData }: VideoProps): React.ReactElement => {
  const { isScreenLG, isScreenMD } = useWindowSize();

  if (!videoData || !videoData.items || videoData.items.length === 0) {
    return <></>;
  }

  const title = videoData.title;
  const videosData = videoData.items;

  const options: Options = {
    perPage: 1,
    gap: "1.5rem",
    pagination: false,
    mediaQuery: "min",
    fixedWidth: getSliderCardSize(isScreenLG, isScreenMD),
    arrows: isScreenLG,
    snap: true,
    breakpoints: {
      992: {
        arrows: videosData.length > 4,
        perPage: 4,
        fixedWidth: undefined,
      },
    },
  };

  return (
    <div className={className} data-testid="videos-component">
      <BlockTitle
        text={title.toUpperCase()}
        rootClassName="mb-4 text-lg md:text-3xl"
      />

      <Splide options={options} hasTrack={false}>
        <div className="splide__arrows absolute bottom-full right-0 flex gap-2">
          <button className="splide__arrow splide__arrow--prev !static !bg-white">
            <FontAwesomeIcon
              icon={faChevronRight}
              size="sm"
              className="block !h-4 !w-4 cursor-pointer rounded-full border border-black fill-gray-650 p-1.5 hover:opacity-100"
            />
          </button>

          <button className="splide__arrow splide__arrow--next !static !bg-white">
            <FontAwesomeIcon
              icon={faChevronRight}
              size="sm"
              className="block !h-4 !w-4 cursor-pointer rounded-full border border-black fill-gray-650 p-1.5 hover:opacity-100"
            />
          </button>
        </div>

        <SplideTrack>
          {videosData.map((video, index) => {
            return (
              <SplideSlide key={`${index}-splide-slide`}>
                <VideoCard videoData={video.videoData} />
              </SplideSlide>
            );
          })}
        </SplideTrack>
      </Splide>
    </div>
  );
};

export default Videos;
